import useSignInWithStartFinalizeQboPageData from '../../hooks/useSignInWithStartFinalizeQboPageData';

const SignInWithStartFinalizeQboPage = () => {
    useSignInWithStartFinalizeQboPageData();

    return null;
};

SignInWithStartFinalizeQboPage.displayName = 'SignInWithStartFinalizeQboPage';

export default SignInWithStartFinalizeQboPage;
